export const Logo = ({ light = false, className = "" }) => (
  <span className={`inline-flex items-center ${className}`} data-testid="brand-logo">
    <img src={light ? "/logo-light.png" : "/logo.png"} alt="866Zerofees.com" className="h-12 w-auto sm:h-14" />
  </span>
);
